import styled from 'styled-components';
const Butterfly = styled.div ``;
export const Styled = {
    Butterfly,
};
//# sourceMappingURL=butterfly.styles.js.map